<div fxLayout="row" fxLayoutAlign="start center" class="widget-container">
    <span class="widget-date">
        <vsc-icon>clock</vsc-icon>
        {{ now$ | async | localizedDate: 'ddd, MMMM D' }}
        <span class="widget-divider ml-8 mr-8">·</span>
        {{ now$ | async | localizedDate: 'hh:mm A' }}
    </span>
</div>
